import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core';

declare const lottie;

@Component({
  selector: 'app-first-use-slide-animation',
  templateUrl: './first-use-slide-animation.component.html',
  styleUrls: ['./first-use-slide-animation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirstUseSlideAnimationComponent {

  waitForAnimation = true;
  animationListener: EventListener;

  @ViewChild('animationElt') animationElt: ElementRef<HTMLDivElement>;

  @Input() animationUrl: string;

  ngAfterViewInit() {
    if (typeof this.animationUrl !== 'undefined') {
      const loadedAnimation = lottie.loadAnimation({
        container: this.animationElt.nativeElement,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: this.animationUrl,
      });
      /* Show the animation once then enable the button */
      loadedAnimation.onLoopComplete = () => {
        this.waitForAnimation = false;
      };
    }
  }
}
